import { AppBar, Divider, Drawer, IconButton } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import React, { Fragment } from 'react';

import Guia from './Guia';
import PainelElementos from './PainelElementos';

const styles = theme => ({
  drawerTitle: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  divider: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  }

});
class DrawerGuiasDuplicidade extends React.Component {
  render () {
    const { open, classes, guias, handleClose } = this.props;

    return (
      <Drawer
        anchor='left'
        open={open}
        onClose={handleClose}
      >
        <div tabIndex={0} role='button'>
          <AppBar position='sticky' color='default' elevation={0}>
            <div className={classes.drawerTitle}>
              <IconButton
                key='close'
                aria-label='Close'
                color='inherit'
                title='Fechar'
                onClick={handleClose}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </AppBar>
          {guias.map((guia, idx) => (
            <Fragment key={idx}>
              <Guia
                guia={guia}
                readOnly={false}
              />
              {/* <PainelElementos
                elementos={guia.elementos}
                emAuditoria={false}
                codLoteGuia={guia.codLoteGuia}
                // readOnly={true}
              /> */}
              <Divider className={classes.divider} />
            </Fragment>
          ))}
        </div>
      </Drawer>
    );
  }
}
export default withStyles(styles)(DrawerGuiasDuplicidade);
